import { API } from '../api';

export async function generateDescription(payload, signal, onDelta) {
  const token = localStorage.getItem('le8_token');
  const response = await fetch(`${API}/admin/ai/description`, {
    method: 'POST', credentials: 'include', signal,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(typeof error.detail === 'string' ? error.detail : 'Vérifiez le nom, la catégorie et la longueur des textes.');
  }
  if (!response.body) throw new Error('La réponse IA est indisponible. Veuillez réessayer.');
  const reader = response.body.getReader(), decoder = new TextDecoder();
  let buffer = '', text = '', draft = null;
  try {
    while (true) {
      const { value, done } = await reader.read();
      buffer += decoder.decode(value, { stream: !done });
      const blocks = buffer.split('\n\n');
      buffer = blocks.pop();
      for (const block of blocks) {
        const line = block.split('\n').find(l => l.startsWith('data: '));
        if (!line) continue;
        const event = JSON.parse(line.slice(6));
        if (event.type === 'error') throw new Error(event.message);
        if (event.type === 'delta') { text += event.text; onDelta(text); }
        if (event.type === 'done') draft = event.draft;
      }
      if (done) break;
    }
  } finally { await reader.cancel().catch(() => {}); reader.releaseLock(); }
  if (!draft) throw new Error('Génération interrompue. Aucun texte n’a été appliqué.');
  return draft;
}

// Incomplete JSON is used solely for a read-only streaming preview, never for saving.
export function partialDescription(text, field) {
  const match = text.match(new RegExp(`"${field}"\\s*:\\s*"((?:\\\\.|[^"\\\\])*)`));
  if (!match) return '';
  try { return JSON.parse(`"${match[1]}"`); } catch { return ''; }
}